import { Database, getDatabase } from 'firebase/database';
import { useFirebaseApp } from './useFirebaseApp';

export const useDatabase = (): Database => {
	return getDatabase(useFirebaseApp());
}
